// extracted by mini-css-extract-plugin
export default {"ScrollToTop":"ScrollToTop_ScrollToTop__5fV5S"};